import Vue from "vue";
import store from "../store/store.js";
import VueRouter from "vue-router";
// import { Role } from "./_helper";

function lazyLoad(view){
  return() => import(/* webpackChunkName: "[request]" */ `@/views/${view}.vue`)
}
function lazyLoadComponent(view){
  return() => import(/* webpackChunkName: "[request]" */ `@/components/${view}.vue`)
}
function lazyLoadSubDirectory(dir, view){
  return() => import(/* webpackChunkName: "[request]" */ `@/views/${dir}/${view}.vue`)
}

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Contacts",
    component: lazyLoadSubDirectory('contact', 'Index'),
    meta: { authorize: [], requiresAuth: true},
  },
  {
    path: "/groups",
    name: "ContactGroups",
    component: lazyLoadSubDirectory('contact', 'Group'),
    meta: { authorize: [], requiresAuth: true},
  },
  {
    path: '/secure/contact-detail/:id?',
    name: 'ContactDetail',
    component: lazyLoadSubDirectory('contact', 'ContactDetail'),
    meta: { authorize: [], requiresAuth: true},
  },

  {
    path: "/search/",
    name: "Search",
    component: lazyLoad("Search"),
    meta: { authorize: [], requiresAuth: true},
  },
  {
    path: "/login",
    name: "Login",
    component: lazyLoadComponent("auth/Login"),
    meta: { authorize: [] },
  },
  {
    path: "/secure/reset/password",
    name: "ResetPassword",
    component: lazyLoad("secure/ResetPassword"),
    meta: { authorize: [] },
  },
];

const router = new VueRouter({
  routes,
});


router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.path.startsWith('/secure/') || record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    else{
      store.dispatch("remoteJwtTokenCheck")
        .then( () => {
          next()
        })
        .catch( () => {
          // console.log('fail jwt token check')
          next('/login') 
        })
    }
  } else {
    next()
  }
})


export default router;
